(function ($) {

	let $form = $("form.checkout_form"),
		$shipping_fields = $form.find(".woocommerce-shipping-fields"),
		script_loaded = false

	// Hide shipping fields on page load when a custom shipping method is selected
	let selected_method = $form.find("input[name='shipping_method']:checked")
	if (selected_method && selected_method.data("method-id") !== 'custom') {
		$shipping_fields.hide()
	}

	function loadScript() {
		if (script_loaded || $('script[src*="accesspointwidget/loader.js"]').length) {
			script_loaded = true
			return
		}
		let $script = $('<script src="https://www.ppl.cz/accesspointwidget/loader.js" async></script>')
		$("body").append($script)
		script_loaded = true
	}

	function isPPLSelected() {
		return $('input[name="shipping_method"][data-method-id="ppl_parcelshop"]').is(":checked")
	}

	function maybePreloadScript() {
		if (isPPLSelected()) {
			loadScript()
		}
	}

	function getCurrentCountry() {
		const $countryInput = $form.find("select[name$='country'], input[name$='country']:checked, input[name$='country']").first()
		const val = $countryInput.val()
		return val ? val.toUpperCase() : null
	}

	function get_ppl_config(country) {
		const config = {
			viewMode: 'modal',
			countriesMenuDisabled: true,
			langMenu: false
		}
		if (country) {
			country = country.toUpperCase()
			config.defaultCountry = country
			config.allowedCountries = [country]
		}
		return config
	}

	function find_widget() {
		return document.getElementById("pplWidget") || document.querySelector("ppl-access-point-widget")
	}

	function update_ppl_country(country) {
		if (!country) return
		country = country.toUpperCase()

		clear_inputs()
		sessionStorage.removeItem("gp_ppl_branch_info")

		$form.find(".ppl_branch").hide()
		const btn = $form.find("a.ppl_select-btn")
		if (btn) {
			btn.text(btn.data('label-select') || 'Vybrat výdejní místo').removeClass('btn-secondary').addClass('btn-primary')
		}

		const widget = find_widget()
		if (widget) {
			if (typeof widget.reset === "function") {
				widget.reset()
			}
			if (typeof widget.configure === "function") {
				widget.configure(get_ppl_config(country))
			}
		}
	}

	function init_ppl_widget() {
		const widget = find_widget()
		if (widget && !widget._pplInitialized) {
			widget._pplInitialized = true
			widget.addEventListener("ppl-accesspointwidget-select", function (e) {
				widgetCallback(e.detail)
			})
			widget.addEventListener("ppl-accesspointwidget-error", function (e) {
				console.error("PPL Widget Error:", e.detail)
			})

			const country = getCurrentCountry()
			if (typeof widget.configure === "function") {
				widget.configure(get_ppl_config(country))
			}
		}
		return widget
	}

	function openPickupWidget() {
		loadScript()

		const country = getCurrentCountry()
		const widget = init_ppl_widget()

		if (widget && typeof widget.open === "function") {
			if (typeof widget.configure === "function") {
				widget.configure(get_ppl_config(country))
			}
			widget.open()
		} else if (widget && window.customElements) {
			customElements.whenDefined("ppl-access-point-widget").then(function () {
				init_ppl_widget()
				if (typeof widget.configure === "function") {
					widget.configure(get_ppl_config(country))
				}
				if (typeof widget.open === "function") {
					widget.open()
				}
			})
		}
	}

	function fill_inputs(locationData) {
		$("input[name='ppl_shipping_address_1']").val(locationData.address_1 || '')
		$("input[name='ppl_shipping_address_2']").val(locationData.address_2 || '')
		$("input[name='ppl_shipping_city']").val(locationData.city || '')
		$("input[name='ppl_shipping_company']").val(locationData.name || '')
		$("input[name='ppl_shipping_country']").val(locationData.country || getCurrentCountry() || '')
		$("input[name='ppl_shipping_postcode']").val(locationData.zip || '')
		$("input[name='ppl_branch_id']").val(locationData.id || '')
		$("input[name='ppl_pickup_point_type']").val(locationData.accessPointType || '')
	}

	function clear_inputs() {
		$("input[name='ppl_shipping_address_1']").val('')
		$("input[name='ppl_shipping_address_2']").val('')
		$("input[name='ppl_shipping_city']").val('')
		$("input[name='ppl_shipping_company']").val('')
		$("input[name='ppl_shipping_country']").val('')
		$("input[name='ppl_shipping_postcode']").val('')
		$("input[name='ppl_branch_id']").val('')
		$("input[name='ppl_pickup_point_type']").val('')
	}

	function display_chosen_pickup_point(locationData) {
		const btn = $form.find("a.ppl_select-btn")
		if (btn) {
			btn.text(btn.data('label-change') || 'Změnit výdejní místo').removeClass('btn-primary').addClass('btn-secondary')
		}

		$form.find(".ppl_branch").show()
		const address_full = `${locationData.address_1 || ''} ${locationData.address_2 || ''}`.trim()
		let addressOutput = `${locationData.name || ''}<br>${address_full}<br>${locationData.zip || ''}, ${locationData.city || ''}`
		$form.find("p#ppl_branch-address").html(addressOutput)
	}

	function splitPickupAddress(address) {
		if (!address) return { address_1: '', address_2: '' }
		let addr = address.trim()

		// Trim leftover whitespace and commas
		addr = addr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/\s{2,}/g, ' ')

		// Trailing number: "Street 12a"
		const trailingNumber = addr.match(/^(.+?)\s+(\d+\w*(?:\/\w+)?)$/)
		if (trailingNumber) {
			return {
				address_1: trailingNumber[1].trim(),
				address_2: trailingNumber[2].trim(),
			}
		}

		// Leading number: "12 Main Street"
		const leadingNumber = addr.match(/^(\d+\w*(?:\/\w+)?)\s+(.+)$/)
		if (leadingNumber) {
			return {
				address_1: leadingNumber[2].trim(),
				address_2: leadingNumber[1].trim(),
			}
		}

		// Can't split - put everything in address_1
		return { address_1: addr, address_2: '' }
	}

	// Save selected store
	function widgetCallback(locationData) {
		if (locationData != null && typeof locationData !== "undefined") {
			var street = locationData.address.street
			var city = locationData.address.city
			var zip = locationData.address.zipCode
			var country = locationData.address.countryCode || getCurrentCountry()
			var name = locationData.name
			var code = locationData.code
			var type = locationData.accessPointType || locationData.type

			let address_split = splitPickupAddress(street)
			var parsedLocation = {
				"address_1": address_split.address_1,
				"address_2": address_split.address_2,
				"city": city,
				"name": name,
				"country": country,
				"zip": zip,
				"id": code,
				"accessPointType": type || 'UNKNOWN',
			}

			sessionStorage.setItem("gp_ppl_branch_info", JSON.stringify(parsedLocation))
			fill_inputs(parsedLocation)
			display_chosen_pickup_point(parsedLocation)

			// Trigger change on shipping method so AJAX can update cart metadata and conditional postnummer field
			let selected_shipping = $form.find("input[name='shipping_method']:checked")
			if (selected_shipping.length) {
				selected_shipping.trigger("change")
			}

			return true
		}

		return false
	}

	function update_data_from_session() {
		let locationData = sessionStorage.getItem("gp_ppl_branch_info")
		if (!locationData) {
			return
		}

		locationData = JSON.parse(locationData)
		fill_inputs(locationData)
		display_chosen_pickup_point(locationData)
	}

	// Init listeners
	$(document).gp_ready(function () {

		$form = $("form.checkout_form")
		$shipping_fields = $form.find(".woocommerce-shipping-fields")

		init_ppl_widget()

		// Update PPL country and reset branch on country change
		$(document).off("change.ppl_country", 'select[name$="country"], input[name$="country"]').on("change.ppl_country", 'select[name$="country"], input[name$="country"]', function () {
			update_ppl_country($(this).val())
		})

		// Open widget on shipping method change to PPL
		$form.find("input[name='shipping_method']").off("change.ppl_select").on("change.ppl_select", function () {
			let method_id = $(this).data("method-id")
			if (method_id === "ppl_parcelshop") {
				let branch_id = $("input[name='ppl_branch_id']").val()
				if (!branch_id) {
					openPickupWidget()
				}
				$shipping_fields.hide()
			} else if (method_id === "custom") {
				$shipping_fields.show()
			}
		})

		// Open widget on choose button click
		$form.find('.ppl_select-btn, [data-open-ppl-pickup-point]').off("click").click(function (e) {
			e.preventDefault()
			openPickupWidget()
		})

		maybePreloadScript()
		update_data_from_session()
	})

})(jQuery)